import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {SettingsFieldLine} from '../../../../settings/common/settingsFieldLine';
import {SettingsToggleItem} from '../../../../settings/common/settingsToggleItem';
import {SettingsTeammateInviteTooltip} from '../../../../settings/teammates/settingsTeammateInviteTooltip';

interface QuickInviteAdminToggleProps {
  value: boolean;
  onToggle: (arg: boolean) => void;
}

export const QuickInviteAdminToggle: FC<QuickInviteAdminToggleProps> = (props) => {
  const {value, onToggle} = props;
  return (
    <SettingsFieldLine
      title={<Trans id="quick-invite-admin-toggle-role-set-admin">Set as company admin</Trans>}
      renderTooltip={() => (
        <SettingsTeammateInviteTooltip
          title={
            <Trans id="quick-invite-admin-toggle-role-set-admin-tooltip-title">
              What is a company admin?
            </Trans>
          }
          body={
            <Trans id="quick-invite-admin-toggle-role-set-admin-tooltip-body">
              This is the highest level of permissions in Front. Company admins can create and delete
              workspaces, manage billing, and configure deliverability settings.
            </Trans>
          }
          learnMoreUrl="https://help.front.com/en/articles/2205#company_admin"
        />
      )}
      content={<SettingsToggleItem value={value} onToggle={onToggle} />}
      isTooltipPersistent
      isTooltipMultiline
      hasNoPadding
      hasNoBorder
      isVerticallyCentered
    />
  );
};
